import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, retry } from 'rxjs';
import { formulas, LU_Tax, Multipliers } from 'scaletech-core';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_TaxService extends StarbaseDataService<LU_Tax> {
  protected _staleDataTimeout = 30000;
  protected _getOneUri = '/api/Taxes/';
  protected _getAllUri = '/api/Taxes';
  protected _postUri = '/api/Taxes';
  protected _putUri = '/api/Taxes/';
  protected _deleteUri = '/api/Taxes/';
  protected _getFormulasUri = '/api/Taxes/GetFormulas';
  protected _broadSearchUri = '/api/Taxes/GetTaxesByFilterParams';
  public allData: LU_Tax[] = [];

  constructor(private _http: HttpClient, private _webAPI: WebApiService) {
      super(_http, _webAPI);
  }

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<LU_Tax>):
          Observable<FilterParams<LU_Tax>> {
            filterParams.collection = [];
            return this._http.post<FilterParams<LU_Tax>>(
              this.server + url, filterParams, { headers: this._webAPI.getApiHeaders('post')}
            ).pipe(
              map((f: FilterParams<LU_Tax>) => {
                f.collection.map((lu: LU_Tax) => {
                  lu.multiplierDisp = {
                    selected: true,
                    key: Multipliers[lu.multiplier],
                    value: lu.multiplier
                  };

                  lu.formulaTaxIncludedDisp = {
                    selected: true,
                    formula: formulas.find(x => x.formulaID === lu.formulaTaxIncluded).formula,
                    formulaID: lu.formulaTaxIncluded
                  };

                  lu.formularTaxNotIncludedDisp = {
                    selected: true,
                    formula: formulas.find(x => x.formulaID === lu.formulaTaxNotIncluded).formula,
                    formulaID: lu.formulaTaxNotIncluded
                  };

                  return lu;
                });
                return f;
              }),
              retry(this.defaultRetries),
              catchError(e => this._webAPI.handleRequestError(e)));
  }

  public getAllData(url: string, retryCount?: number): Observable<LU_Tax[]> {
    return super.getAllData(url, retryCount).pipe(
      map((l: LU_Tax[]) =>
        l.map(
          (lu: LU_Tax) => {
            lu.multiplierDisp = {
              selected: true,
              key: Multipliers[lu.multiplier],
              value: lu.multiplier
            };

            lu.formulaTaxIncludedDisp = {
              selected: true,
              formula: formulas.find(x => x.formulaID === lu.formulaTaxIncluded).formula,
              formulaID: lu.formulaTaxIncluded
            };

            lu.formularTaxNotIncludedDisp = {
              selected: true,
              formula: formulas.find(x => x.formulaID === lu.formulaTaxNotIncluded).formula,
              formulaID: lu.formulaTaxNotIncluded
            };

            return lu;
          })
      ));
  }
}
